import { render, staticRenderFns } from "./ProductosComponent.vue?vue&type=template&id=9262c038"
import script from "./ProductosComponent.vue?vue&type=script&lang=js"
export * from "./ProductosComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports